var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DataLabel',{attrs:{"item":"","icon-class":_vm.iconClass}},[_c('TagsBadges',{attrs:{"tags":_vm.selectedTags,"none":_vm.$t('common.labels.tags.nil')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }